import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable, switchMap } from 'rxjs';
import { filter } from 'rxjs/operators';

import { MaintenancePeriod } from '../../../admin/components/maintenance-period/model/maintenance-period';
import { AppState } from '../../../shared/store/app-state';
import { toHugeDate, toTime } from '../../../utils/date';
import { getCurrentMaintenancePeriod } from '../../store/selectors/maintenancePeriods';

@Component({
    selector: 'app-maintenance-period-card',
    imports: [TranslatePipe, AsyncPipe],
    templateUrl: './maintenance-period-card.component.html',
    styleUrl: './maintenance-period-card.component.scss',
})
export class MaintenancePeriodCardComponent {
    private readonly store = inject<Store<AppState>>(Store);
    private readonly translateService = inject(TranslateService);

    protected content$: Observable<MaintenancePeriod>;

    constructor() {
        this.content$ = this.store.select(getCurrentMaintenancePeriod).pipe(
            filter(Boolean),
            switchMap(({ startDate, endDate }) => {
                return this.translateService.stream('MAINTENANCE_PERIOD_MODAL_CONTENT', {
                    date: toHugeDate(startDate),
                    startTime: toTime(startDate * 1000),
                    endTime: toTime(endDate * 1000),
                });
            }),
        );
    }
}
